import axios from "axios";

export const createEnviroment = async (
  token: string,
  roomName: string,
  spaceId: string
) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_PATH}/automation/room`,
      {
        roomName,
        spaceId,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    )
    .then(({ data }) => {
      return data;
    });
};
